import React from 'react';
import { homeView as HomeView } from './homeView';
import '../../css/login.css';
import APP from '../../modules';

class HomeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      showTestDesign: false,
      showTestBug: false,
      showTestData: false
    };
  }

  componentDidMount() {
    sessionStorage.removeItem('checkId');
  }

  onChange = (event) => {
    const { value, name } = event.currentTarget;
    this.setState({ [name]: value });
  };
  testDesignClick = (val) => {
    val === 'TestData'
      ? this.setState({ showTestData: true, showTestDesign: false, showTestBug: false })
      : val === 'BugCreation' ? this.setState({ showTestData: false, showTestDesign: false, showTestBug: true }) 
      : this.setState({ showTestData: false, showTestDesign: true, showTestBug: false });
  };

  testViewClick = (val) => {
    if (val === 'TestData') {
      sessionStorage.setItem('TestCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.VIEW_REQUIREMENT);
    } else {
      sessionStorage.setItem('TestCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.VIEW_REQUIREMENT);
    }
  };

  testNewClick = (val) => {
    if (val === 'TestData') {
      sessionStorage.setItem('TestCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.TEST_DATA_MANAGEMENT);
    } else {
      sessionStorage.setItem('TestCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.TEST_CONFIG);
    }
  };

  testBugClick = (val) => {
      sessionStorage.setItem('BugCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.BUG_CREATION);
  };

  render() {
    return (
      <HomeView
        {...{
          ...this.state,
          onChange: this.onChange,
          testDesignClick: this.testDesignClick,
          testViewClick: this.testViewClick,
          testBugClick: this.testBugClick,
          testNewClick: this.testNewClick
        }}
      />
    );
  }
}

export default HomeComponent;
